import { SvgIcon } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import { matomo } from '@websrc/App/Tracking/Matomo'
import clsx from 'clsx'
import { button, styles, visuallyHidden } from 'leds'
import React, { ComponentPropsWithoutRef, FC, ReactNode, useContext } from 'react'

export type AccordionProps = ComponentPropsWithoutRef<'div'> & {
  label: string | ReactNode
  isOpen: boolean
  onAccordionClick?(isOpen: boolean): void
  buttonClassName?: string
  accordionId: string
  children: ReactNode
}

export const Accordion: FC<AccordionProps> = ({
  label,
  children,
  className,
  isOpen,
  onAccordionClick,
  buttonClassName,
  accordionId,
  ...divProps
}) => {
  const { matomoPageTemplate } = useContext(AppProviderContext)

  return (
    <div {...divProps} className={className}>
      <button
        aria-expanded={isOpen}
        className={clsx(
          buttonClassName,
          button({ type: 'clean' }),
          styles({
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: 'full',
            paddingY: 5,
          })
        )}
        onClick={() => {
          matomo.trackEvent('engagement', matomoPageTemplate, [], [accordionId], 'accordion')
          onAccordionClick?.(isOpen)
        }}
      >
        {label}
        <div>
          <SvgIcon name={isOpen ? 'MINUS' : 'PLUS'} size={25} strokeWidth={4} />
        </div>
      </button>
      <div
        aria-hidden={!isOpen}
        className={clsx(isOpen ? null : visuallyHidden)}
        data-testid={'accordion content'}
      >
        {children}
      </div>
    </div>
  )
}
